import { Modal, Box, Typography, Button } from '@mui/material';
import { useAuth } from 'src/contexts/AuthContext';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

export const TokenExpiredModal = () => {
  const { showExpirationModal, closeExpirationModal } = useAuth();

  return (
    <Modal
      open={showExpirationModal}
      onClose={closeExpirationModal}
      aria-labelledby="token-expired-modal"
    >
      <Box sx={style}>
        <Typography variant="h6" component="h2" gutterBottom>
          Session Expired
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Your session has expired. Please log in again to continue.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={closeExpirationModal}
        >
          Okay
        </Button>
      </Box>
    </Modal>
  );
};